import React, { useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const TaskCompletionModal = ({ show, handleClose, task, onCompleteTask }) => {
    const [closureNote, setClosureNote] = useState('');
    const [referenceUrls, setReferenceUrls] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleSubmit = () => {
        if (!closureNote.trim()) {
            alert('Closure note is required');
            return;
        }
        
        onCompleteTask(task.id, {
            status: 'COMPLETED',
            closure_note: closureNote,
            reference_urls: referenceUrls,
            actual_start_date: startDate || null,
            actual_end_date: endDate || null
        });
        
        setClosureNote('');
        setReferenceUrls('');
        setStartDate('');
        setEndDate('');
        handleClose();
    };

    if (!task) return null;

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Complete Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <h6>Task: {task.title}</h6>
                    <p className="text-muted">{task.overview}</p>
                </div>
                
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Actual Start Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Actual End Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Closure Note *</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={closureNote}
                            onChange={(e) => setClosureNote(e.target.value)}
                            placeholder="Describe how the task was completed, what was delivered, any issues encountered..."
                            required
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3">
                        <Form.Label>Reference URLs</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={referenceUrls}
                            onChange={(e) => setReferenceUrls(e.target.value)}
                            placeholder="Links to documentation, deliverables, related resources (one per line)"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                <Button 
                    variant="success" 
                    onClick={handleSubmit}
                    disabled={!closureNote.trim()}
                >
                    Complete Task
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TaskCompletionModal;
